const SCROLL_LOCK_CLASS = 'hm-scroll-locked'

let lockCount = 0
let savedScrollY = 0

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return
  lockCount++
  if (lockCount !== 1) return

  savedScrollY = window.scrollY
  document.documentElement.classList.add(SCROLL_LOCK_CLASS)
  document.body.classList.add(SCROLL_LOCK_CLASS)
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') return
  if (lockCount <= 0) return
  lockCount--
  if (lockCount !== 0) return

  document.documentElement.classList.remove(SCROLL_LOCK_CLASS)
  document.body.classList.remove(SCROLL_LOCK_CLASS)
  window.scrollTo(0, savedScrollY)
}
